import { createModel } from '@rematch/core';
import { Statement } from '../../models/statement';
import { storeById } from '../../utils/converter';
import {
    getStatementAsync,
    getStatementsAsync
} from '../../apis/statement';

export interface State {
    allIds: string[];
    byId: Dictionary<Statement>;
    loading: Dictionary<boolean>;
}

export const statements = createModel<State>({
    state: {
        allIds: [],
        byId: {},
        loading: {}
    },
    reducers: {
        update: (
            state: State,
            data: Undefinable<MixType<Statement>>,
            loadingKey?: string
        ): State => {
            const byId = {
                ...state.byId,
                ...storeById(data)
            };
            return {
                ...state,
                ...Object.keys(byId).length > state.allIds.length && {
                    allIds: Object.keys(byId)
                        .sort((a, b) => byId[a]!.statementDate > byId[b]!.statementDate ? 1 : -1)
                },
                byId: byId,
                ...loadingKey && {
                    loading: {
                        ...state.loading,
                        [loadingKey]: false
                    }
                }
            };
        },
        loading: (
            state: State,
            loadingKey: string,
            loading: boolean
        ): State => ({
            ...state,
            loading: {
                ...state.loading,
                [loadingKey]: loading
            }
        })
    },
    effects: () => ({
        async getStatementsAsync() {
            this.loading('getStatementsAsync', true);
            try {
                const response = await getStatementsAsync();
                if (response.success) {
                    this.update(response.data, 'getStatementsAsync');
                } else {
                    window.console.log(response.message);
                    window.alert('Get statement failed');
                    this.loading('getStatementsAsync', false);
                }
            } catch (e) {
                window.console.log(e);
                this.loading('getStatementsAsync', false);
            }
        },
        async getStatementAsync(id: string) {
            this.loading(`getStatementAsync---${id}`, true);
            try {
                const response = await getStatementAsync(id);
                if (response.success) {
                    this.update(response.data, `getStatementAsync---${id}`);
                } else {
                    window.console.log(response.message);
                    window.alert('Get statement failed');
                    this.loading(`getStatementAsync---${id}`, false);
                }
            } catch (e) {
                window.console.log(e);
                this.loading(`getStatementAsync---${id}`, false);
            }
        }
    })
});
